import { H5, Icon } from "@sellar-io/components";
import dayjs from "dayjs";
import { ErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";
import styles from "../../App.module.css";
import * as ROUTES from "../../constants/routes";
import { useMenuDrawerContext } from "../menu/MenuDrawerContextProvider.shared";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { AppRoutingBoundary } from "../../routing/AppRoutingBoundary";
import { AlertContainer } from "../alert/AlertContainer";
import { ErrorMessageBoundary } from "../errorMessage/ErrorMessage";
import { useFeatureFlagStore } from "../../hooks/useFeatureFlags";
import { SessionTestPanel } from "./SessionTestPanel";
import { sessionTestControlsEnabled } from "../../hooks/sessionTestControls";
import { useAppChrome } from "./useAppChrome";

export const AppContent = () => {
  const { isMobileViewport } = useMenuDrawerContext();
  const { business } = useSellarCurrentBusiness();
  const { mode: appChromeMode } = useAppChrome();
  const navigate = useNavigate();
  const sessionTestingActive = useFeatureFlagStore((store) =>
    store.isActive("SESSION_TESTING"),
  );
  const showSessionTesting = sessionTestControlsEnabled && sessionTestingActive;

  return (
    <div
      className={twMerge(
        styles.container,
        "max-w-full min-w-0 grow overflow-x-clip bg-neutral-100",
        // Desktop chrome owns the viewport height so flex children fill space
        // under the PWA update banner. Mobile keeps document scroll for iOS.
        !isMobileViewport && "h-full min-h-0 overflow-x-hidden overflow-y-auto",
      )}
    >
      {appChromeMode === "operational" &&
        business?.Supplier?.SupplierOutOfOffice?.outOfOffice && (
          <div className="p-1">
            <AlertContainer className="w-full" type="information">
              <div className="flex flex-row items-center">
                <div className="flex shrink-0 items-start">
                  <Icon
                    size={0.8}
                    icon="INFORMATION"
                    className="mr-2 text-blue-800"
                  />
                </div>
                <div className="flex w-full flex-row items-center justify-between">
                  <H5>
                    Out of office mode on until{" "}
                    {dayjs(
                      business.Supplier.SupplierOutOfOffice.returnDate,
                    ).format("DD/MM/YY")}
                    . Turn off manually by configuring your storefront.
                  </H5>
                  <p
                    className="flex-end inline-flex cursor-pointer font-bold text-blue-800"
                    onClick={() => navigate(ROUTES.STOREFRONT_SETTINGS)}
                  >
                    Configure storefront <Icon icon="CHEVRON_RIGHT" />
                  </p>
                </div>
              </div>
            </AlertContainer>
          </div>
        )}
      {showSessionTesting && <SessionTestPanel />}
      <ErrorBoundary FallbackComponent={ErrorMessageBoundary}>
        <AppRoutingBoundary />
      </ErrorBoundary>
    </div>
  );
};
